"use client"

import { useEffect, useState } from "react"
import styles from "./floating-actions.module.css"

const SCROLL_TOP_THRESHOLD = 300

export default function FloatingActions({ whatsapp = { enabled: true, phone_number: "905324577387" } }: { whatsapp?: { enabled: boolean; phone_number: string } }) {
  const [scrollTopVisible, setScrollTopVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrollTopVisible(window.scrollY > SCROLL_TOP_THRESHOLD)
    onScroll()
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  const scrollToTop = () => {
    const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false
    window.scrollTo({ top: 0, behavior: reducedMotion ? "auto" : "smooth" })
  }

  return (
    <div
      className={styles.stack}
      data-testid="floating-actions"
      data-scroll-visible={scrollTopVisible ? "true" : "false"}
    >
      {whatsapp.enabled ? <a
        className={styles.whatsapp}
        href={`https://wa.me/${whatsapp.phone_number}`}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp support"
      >
        <span className={styles.whatsappIcon} aria-hidden="true">
          <img src="/vetpets/whatsapp.png" alt="" width="28" height="28" />
        </span>
      </a> : null}

      <button
        type="button"
        className={`${styles.scrollToTop} ${scrollTopVisible ? styles.visible : ""}`}
        aria-label="Scroll to top"
        data-visible={scrollTopVisible ? "true" : "false"}
        onClick={scrollToTop}
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="m18 15-6-6-6 6" />
        </svg>
      </button>
    </div>
  )
}
